export default "__VITE_ASSET__DGghxjU3__"